import React from 'react'
import {assets} from '../assets/assets.js'
import { Link, useLocation} from 'react-router-dom'

const NavBar = () => {
    const location = useLocation()
    const isAboutPage = location.pathname === '/AboutPage'

  return (
    <div className='sticky top-0 bg-gradient-to-b from-black/80 to-transparent w-full overflow-x-hidden'>
        <div className='flex items-center justify-between px-4 py-2 w-full'>
            <div className='flex-1 text-left'>
                <Link to={isAboutPage ? '/' : "/AboutPage"}>
                    <p className={`inline-block px-2 py-1 sm:px-3 border-2 rounded-full bg-black font-bold cursor-pointer text-sm transition-colors ${
                        isAboutPage
                            ? 'border-pink-500 text-pink-400 hover:bg-pink-950'
                            : 'border-gray-500 text-gray-200 hover:bg-gray-800'
                    }`}>
                        {isAboutPage ? 'Home Page' : 'About Page'}
                    </p>
                </Link>
            </div>
            <div className='flex-1 flex justify-center'>
                <img
                    src={assets.wmlogo}
                    className="w-12 height-auto"
                    style={{ willChange: 'transform' }}
                    alt='Logo'
                />
            </div>
            <div className='flex-1 flex justify-end items-center gap-2 pr-1'>
                <a href="https://github.com/walkmoody" target="_blank" rel="noopener noreferrer"
                   className="text-gray-400 hover:text-pink-400 transition-colors text-sm font-semibold border border-gray-700 rounded-full px-3 py-1 hover:border-pink-500">
                    GitHub
                </a>
                <a href="https://www.linkedin.com/in/walkermoody/" target="_blank" rel="noopener noreferrer"
                   className="text-gray-400 hover:text-cyan-400 transition-colors text-sm font-semibold border border-gray-700 rounded-full px-3 py-1 hover:border-cyan-500">
                    LinkedIn
                </a>
            </div>
        </div>
    </div>
  )
}

export default NavBar
